import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import { useLoggedOutRetailerNodes } from "../../hooks/useLoggedOutRetailerNodes";
var DEFAULT_REGION = "USA";
export var useFilteredArticles = function useFilteredArticles(articles, issueL2, loggedOutExperience) {
  var region = useRegion();
  var hcArticles = useArticles();
  var retailerNodes = useLoggedOutRetailerNodes();
  return articles.filter(function (article) {
    if (issueL2 === retailerNodes.L2.BuyingInternational && !loggedOutExperience) {
      return article === hcArticles.ImportFeesAndDuties[region];
    }
    return article;
  });
};
var useRegion = function useRegion() {
  var retailerCountry = useRetailerCountry();
  if (isEuropeanCountry(retailerCountry)) {
    return "Europe";
  } else if (retailerCountry === ISO3166Alpha3.USA) {
    return "USA";
  } else if (retailerCountry === ISO3166Alpha3.CAN) {
    return "Canada";
  }
  return DEFAULT_REGION;
};
var useRetailerCountry = function useRetailerCountry() {
  var _retailer$default_shi, _retailer$default_shi2;
  var retailer = getRetailer();
  return (_retailer$default_shi = retailer === null || retailer === void 0 ? void 0 : (_retailer$default_shi2 = retailer.default_shipping_address) === null || _retailer$default_shi2 === void 0 ? void 0 : _retailer$default_shi2.country) !== null && _retailer$default_shi !== void 0 ? _retailer$default_shi : retailer === null || retailer === void 0 ? void 0 : retailer.country;
};
var isEuropeanCountry = function isEuropeanCountry(country) {
  return THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.map(String).includes(country !== null && country !== void 0 ? country : "");
};